import { AnyAction } from "redux";
import { SET_INTERFACE_CODE, SET_INVESTOR_CLIENTID, SET_IWAPP_RMID, SET_APPLICATION_ID, VERIFY_OTP_PAYMENT_SUCCESS, SET_IS_PORTFOLIO_AVAILABLE, SET_APPLICANT_DETAILS, SET_FAMILY_DETAILS, SET_SHOW_MFC_REPORT, SET_APPLICANT_ID, SET_APPLICATION_TYPE, SET_BSE_CLIENT_ACTIVATION_STATUS, SET_IS_BSE_ENABLED, SET_PORTFOLIO, SET_APPLICATION_ID_FOR_NOMINEECHECK } from "../types/onBoarding";
import { LOGOUT_SUCCESS } from "../types/auth";
import { PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS } from "../types/cart";

export interface IdType {
    iwappRmId: string | number;
    investorClientId: string;
    clientInterfaceCode: string | null;
    portfolio: string;
    applicationId?: string | number;
    applicantId?: string | number;
    panNo: string;
    email: string;
    mobile: string;
    countryCode: string;
    isPortfolioAvailable: boolean;
    familyId: string;
    familyName: string;
    showMfcReport: boolean;
    applicationType?: string;
    investorName?:string;
    status?:string;
    onboardingType?:string
    bseClientActivationStatus: string;
    isBSEEnabled?: boolean;
    investorType?:string;
    applicationIdForNomineeCheck:string
}

const initState = {
    iwappRmId: '',
    investorClientId: '',
    clientInterfaceCode: '',
    portfolio: '',
    applicationId: '',
    isPortfolioAvailable: false,
    familyId: "",
    familyName: "",
    showMfcReport: false,
    applicantId:"",
    applicationType:"",
    status:"",
    onboardingType:"",
    bseClientActivationStatus: "",
    isBSEEnabled: false,
    investorType:"",
    applicationIdForNomineeCheck:''

}

export default function idReducer(state = initState, action: AnyAction): Partial<IdType> {
    switch (action.type) {

        case PAYMENT_OPEN_FLOW_VALIDATE_OTP_SUCCESS: {
            return {
                ...state,
                investorClientId: action?.body?.clientCode ?? "",
            }
        }
        case VERIFY_OTP_PAYMENT_SUCCESS: {
            return {
                ...state,
                investorClientId: action?.body?.clientCode ?? "",
            }
        }
        case SET_IWAPP_RMID: {
            // console.log("action", action);
            return {
                ...state,
                iwappRmId: action.iwappRmId
            };
        }

        case SET_INVESTOR_CLIENTID: {
            return {
                ...state,
                investorClientId: action.investorClientId
            };
        }

        case SET_INTERFACE_CODE: {
            return {
                ...state,
                clientInterfaceCode: action.clientInterfaceCode
            };
        }

        case SET_PORTFOLIO: {
            return {
                ...state,
                portfolio: action.portfolio
            };
        }

        case SET_APPLICATION_ID: {
            return {
                ...state,
                applicationId: action.applicationId
            }
        }

        case SET_APPLICATION_ID_FOR_NOMINEECHECK:{
            return {
                ...state,
                applicationIdForNomineeCheck:action.applicationIdForNomineeCheck
            
            };
        }

        case SET_APPLICANT_DETAILS: {
            return {
                ...state,
                panNo: action.body?.panNo ?? "",
                email: action.body?.email ?? "",
                mobile: action.body?.mobile ?? "",
                countryCode: action.body?.countryCode ?? ""
            }
        }

        case SET_IS_PORTFOLIO_AVAILABLE: {
            return {
                ...state,
                isPortfolioAvailable: action.isPortfolioAvailable
            }
        }

        case SET_FAMILY_DETAILS: {
            return {
                ...state,
                familyId: action.body?.familyId ?? "",
                familyName: action.body?.familyName ?? ""
            };
        }

        case SET_SHOW_MFC_REPORT: {
            return {
                ...state,
                showMfcReport: action.showMfcReport
            }
        }

        case SET_APPLICANT_ID: {
            return {
                ...state,
                applicantId: action.applicantId
            }
        }
        case SET_APPLICATION_TYPE: {
            return {
                ...state,
                applicationType: action.applicationType,
                investorName:action.investorName,
                status:action.status,
                onboardingType:action.onboardingType,
                investorType:action.investorType
            }
        }

        case SET_BSE_CLIENT_ACTIVATION_STATUS: {
            return {
                ...state,
                bseClientActivationStatus: action.bseClientActivationStatus
            }
        }

        case SET_IS_BSE_ENABLED: {
            return {
                ...state,
                isBSEEnabled: action.isBSEEnabled
            }
        }

        case LOGOUT_SUCCESS: {
            return initState;
        }

        default:
            return state;
    }
}